
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/district-filter",
      function () {
        return require("private-next-pages/district-filter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/district-filter"])
      });
    }
  